import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, IconButton, } from '@material-ui/core';

const ICON = require("../../../images/icons/jia.png");
const ICON_DEL = require("../../../images/icons/ic_channel_remove.png");

class ChanelsItem extends React.Component {

    render() {
        const { classes, data, add, del } = this.props;
        return (
            <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                <Grid container justify='flex-end' style={{ width: '100%', }}>
                    {
                        add && <IconButton className={classes.iconButton} onClick={() => this.props.onClick && this.props.onClick()}>
                            <img src={ICON} style={{ width: 10, height: 10, marginRight: 8 }} />
                        </IconButton>
                    }
                    {
                        del && <IconButton className={classes.iconButton} onClick={() => this.props.onClick && this.props.onClick()}>
                            <img src={ICON_DEL} style={{ width: 10, height: 10, marginRight: 8 }} />
                        </IconButton>
                    }
                </Grid>
                <img src={data.logo} className={classes.img}></img>
                <Typography className={classes.contentText}>{data.name}</Typography>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: 78,
        height: 78,
        borderRadius: 10,
        backgroundColor: '#F5F5F5',
    },
    img: {
        height: 26,
        width: 26,
        marginTop: 4,
        objectFit: 'scale-down'
    },
    contentText: {
        color: '#0D0D0D',
        fontSize: 12,
        marginTop: 4,
    },
    subTitle: {
        color: '#878787',
        fontSize: 10,
        marginTop: 4,
        marginBottom: 4,
    },
    iconButton: {
        padding: theme.spacing(0),
        margin: theme.spacing(0),
    }
}))(ChanelsItem));